import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import BuilderAx          from 'app/actions/company-admin/builder-vol-event';
import RoutingAx          from 'app/actions/routing';
import Checkbox           from 'app/components/common/checkbox';
import Confirm            from 'app/components/common/confirm';
import Icon               from 'app/components/common/icon';
import AddressInput       from 'app/components/common/address-input';
import NonprofitInput     from 'app/components/common/nonprofit-input';
import NteePicker         from 'app/components/common/ntee-picker';
import Popper             from 'app/components/common/popper';
import RteEditor          from 'app/components/common/rich-text/editor';
import SegmentedInput     from 'app/components/common/segmented-selector-input';
import StandardInput      from 'app/components/common/standard-input';
import TimezoneInput      from 'app/components/common/timezone-input';
import UploadedImageInput from 'app/components/common/uploaded-image-input';
import BuilderLink        from 'app/components/company-admin/common/builder-link';
import EntityInput        from 'app/components/company-admin/common/entity-input';
import CalendarPicker     from 'app/components/company-admin/integrations/calendar-picker';
import Builder            from 'app/components/company-admin/layout/builder';
import BuilderFooter      from 'app/components/company-admin/layout/builder-footer';
import BuilderIterable    from 'app/components/company-admin/layout/builder-iterable';
import BuilderSection     from 'app/components/company-admin/layout/builder-section';
import ShiftBuilder       from 'app/components/company-admin/volunteer/builder-shift';
import config             from 'app/config';
import {
  VolEventTypes,
  VolEventTags as Tags,
  VolEventTagNames as TagNames,
  VolEventTagIcons as TagIcons,
}                         from 'app/constants';
import IntsDuck           from 'app/ducks/company-admin/integrations';
import Ps                 from 'app/helpers/publish-statuses';
import CadminSlx          from 'app/selectors/company-admin/';
import BuilderSlx         from 'app/selectors/company-admin/builder-vol-event';
import FfSlx              from 'app/selectors/feature-flags';

const locOpts = [
  {value: 'remote',    label: 'Remote'},
  {value: 'in-person', label: 'In-Person'},
  {value: 'hybrid',    label: 'Hybrid'},
];
const attrsToLocType = ({isRemote, isHybrid}) => {
  if (isRemote) return 'remote';
  return isHybrid ? 'hybrid' : 'in-person';
};

class VolEventBuilder extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      shiftDeleteIndex: null,
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeImg = this.onChangeImg.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeExternalUrl = this.onChangeExternalUrl.bind(this);
    this.onChangeDetails = this.onChangeDetails.bind(this);
    this.onChangeContact = this.onChangeContact.bind(this);
    this.onChangeNonprofit = this.onChangeNonprofit.bind(this);
    this.onChangeNteeCode = this.onChangeNteeCode.bind(this);
    this.onChangeLeadEmployee = this.onChangeLeadEmployee.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onChangeTimezone = this.onChangeTimezone.bind(this);
    this.onChangeIsOngoing = this.onChangeIsOngoing.bind(this);
    this.onChangeLocType = this.onChangeLocType.bind(this);
    this.onChangeHasSocialFeed = this.onChangeHasSocialFeed.bind(this);
    this.onChangeNylasCalendarId = this.onChangeNylasCalendarId.bind(this);
    this.onClickAddShift = this.onClickAddShift.bind(this);
    this.onRemoveShift = this.onRemoveShift.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.onRemoveGroup = this.onRemoveGroup.bind(this);
    this.onSetPrimaryGroup = this.onSetPrimaryGroup.bind(this);
    this.onClickAddGroup = this.onClickAddGroup.bind(this);
    this.onRemoveLink = this.onRemoveLink.bind(this);
    this.onChangeLink = this.onChangeLink.bind(this);
    this.onClickAddLink = this.onClickAddLink.bind(this);
    this.onResponseDeleteShift = this.onResponseDeleteShift.bind(this);
  }

  componentDidUpdate() {
    Popper.updateAll();
  }

  componentDidMount() {
    this.props.setHasChanges(() => this.hasChanges);
  }

  componentWillUnmount() {
    this.props.setHasChanges(false);
  }

  get isEvent() {
    return this.props.type === VolEventTypes.EVENT;
  }

  get hasIntl() {
    return !!this.props.company?.features?.international;
  }

  get hasChanges() {
    return !!(this.props.hasTouched || this.props.savePending);
  }

  onChangeTitle(event) {
    const title = event.target.value;
    this.props.setKeyVal('title', title);
  }

  onChangeImg(imgPath) {
    this.props.setKeyVal('imgPath', imgPath);
  }

  onChangeDescription(md) {
    this.props.setKeyVal('descriptionMd', md);
  }

  onChangeExternalUrl(event) {
    const externalUrl = event.target.value;
    this.props.setKeyVal('externalUrl', externalUrl);
  }

  onChangeDetails(event) {
    const details = event.target.value;
    this.props.setKeyVal('details', details);
  }

  onChangeContact(event) {
    const contact = event.target.value;
    this.props.setKeyVal('contact', contact);
  }

  onChangeNonprofit(nonprofit) {
    this.props.setNonprofit(nonprofit);
  }

  onChangeNteeCode(nteeCode) {
    this.props.setKeyVal('nteeCode', nteeCode);
  }

  onChangeTag(tag, event) {
    const checked = event.target.checked;
    this.props.setTag(tag, checked);
  }

  onChangeLeadEmployee(emp) {
    this.props.setKeyVal('leadEmployeeId', emp?.id || null);
  }

  onChangeAddress(address) {
    const keyVals = _.pick(address, ['addressLine1', 'city', 'state', 'postalCode', 'latitude', 'longitude', 'timezone']);
    this.props.setKeyVals(keyVals);
  }

  onChangeTimezone(timezone) {
    this.props.setKeyVal('timezone', timezone);
  }

  onChangeIsOngoing(event) {
    const isOngoing = event.target.checked;
    const keyVals = {isOngoing};
    if (isOngoing) {
      keyVals.nylasCalendarId = null;
    }
    this.props.setKeyVals(keyVals);
  }

  onChangeLocType({value: locType}) {
    if (locType === 'remote') {
      return this.props.setKeyVals({isRemote: true, isHybrid: false});
    }
    if (locType === 'in-person') {
      return this.props.setKeyVals({isRemote: false, isHybrid: false});
    }
    if (locType === 'hybrid') {
      return this.props.setKeyVals({isRemote: false, isHybrid: true});
    }
  }

  onChangeHasSocialFeed(event) {
    const hasSocialFeed = event.target.checked;
    this.props.setKeyVal('hasSocialFeed', hasSocialFeed);
  }

  onChangeNylasCalendarId(nylasCalendarId) {
    this.props.setKeyVal('nylasCalendarId', nylasCalendarId);
  }

  onClickAddShift() {
    this.props.addShift();
  }

  onRemoveShift(index) {
    const shift = this.props.shifts[index];
    if (shift?.id) {
      this.setState({shiftDeleteIndex: index});
    } else {
      this.props.removeShift(index);
    }
  }
  onResponseDeleteShift(didConfirm) {
    const {shiftDeleteIndex} = this.state;
    this.setState({shiftDeleteIndex: null});
    if (!didConfirm) return;
    this.props.removeShift(shiftDeleteIndex);
  }

  onClickSave() {
    this.props.save();
  }

  onClickAddGroup() {
    const index = this.props.groups.length;
    this.props.setGroup(null, index);
  }
  onRemoveGroup(index) {
    this.props.removeGroup(index);
  }
  onChangeGroup(index, group) {
    this.props.setGroup(group, index);
  }
  onSetPrimaryGroup(index) {
    this.props.setPrimaryGroup(index);
  }

  onClickAddLink() {
    this.props.addLink();
  }
  onChangeLink(index, link) {
    this.props.updateLink(index, link);
  }
  onRemoveLink(index) {
    this.props.removeLink(index);
  }

  /*
   *  Render Sections
   */

  renderSectionTitle() {
    const { title, validations } = this.props;
    const heading = this.isEvent ? 'Group Event Name' : 'Volunteer Event Name';
    return (
      <BuilderSection title={heading} isRequired>
        <StandardInput label="Name" name="title" value={title || ''} validations={validations} onChange={this.onChangeTitle} />
      </BuilderSection>
    );
  }

  renderSectionImg() {
    const { imgPath, validations } = this.props;
    return (
      <BuilderSection title="Image" isRequired>
        <UploadedImageInput
          name="imgPath"
          label="Image"
          onChange={this.onChangeImg}
          s3PathParts={['vol-events']}
          maxImageWidth={2048}
          pathValue={imgPath}
          validations={validations}
        />
      </BuilderSection>
    );
  }

  renderSectionDescription() {
    const { descriptionMd, hasLoaded, externalUrl, isSystemEvent, validations, links, hasSubmitted } = this.props;
    return (
      <BuilderSection title="Short Description" isRequired>
        {hasLoaded && (
          <RteEditor initialMd={descriptionMd} onChange={this.onChangeDescription} validations={validations} name="descriptionMd" placeholder="Description" />
        )}
        {isSystemEvent && (
          <StandardInput type="text" label="External URL" name="externalUrl" value={externalUrl || ''} onChange={this.onChangeExternalUrl} validations={validations} />
        )}
        {links.map((link, index) => {
          return (
            <BuilderIterable index={index} key={index} onDelete={this.onRemoveLink}>
              <BuilderLink link={link} index={index} onChange={this.onChangeLink} hasSubmitted={hasSubmitted} />
            </BuilderIterable>
          );
        })}
        <button className="btn small blue cadmin-builder-iterable-add" onClick={this.onClickAddLink}>+ Add Button</button>
      </BuilderSection>
    );
  }

  renderSectionLocation() {
    const { addressLine1, city, state, postalCode, timezone, isRemote, isHybrid, validations } = this.props;
    const address = addressLine1 ? {addressLine1, city, state, postalCode, timezone} : null;
    return (
      <BuilderSection title="Location" isRequired>
        <SegmentedInput options={locOpts} value={attrsToLocType({isRemote, isHybrid})} onChange={this.onChangeLocType} stretch className="_mb-18" />
        {isRemote ? (
          <TimezoneInput onChange={this.onChangeTimezone} timezone={timezone} name="timezone" validations={validations} />
        ) : (
          <AddressInput label="Address" name="address" address={address} onChange={this.onChangeAddress} validations={validations} />
        )}
      </BuilderSection>
    );
  }

  renderSectionTime() {
    const { isOngoing, shifts, hasSubmitted, type, showShiftRequiredValidation } = this.props;
    const topRight = (
      <div className="cadmin-builder-checkbox">
        <Checkbox id="checkbox-is-ongoing" onChange={this.onChangeIsOngoing} checked={isOngoing} />
        <label htmlFor="checkbox-is-ongoing">Ongoing</label>
      </div>
    );
    return (
      <BuilderSection title="Time" topRight={topRight} isRequired>
        {showShiftRequiredValidation && (
          <p className="cadmin-builder-section-vmsg">When not ongoing, at least one shift is required.</p>
        )}
        {!isOngoing && (<>
          {shifts.map((shift, i) => {
            if (shift._delete) return null;
            return (
              <BuilderIterable index={i} key={i} onDelete={this.onRemoveShift} className="cadmin-veb-shift-iterable">
                <ShiftBuilder shift={shift} index={i} type={type} hasSubmitted={hasSubmitted} />
              </BuilderIterable>
            );
          })}
          <button className="btn small blue cadmin-builder-iterable-add" onClick={this.onClickAddShift}>+ Add Shift</button>
        </>)}
      </BuilderSection>
    );
  }

  renderSectionNonprofit() {
    const { nonprofit, type } = this.props;
    return (
      <BuilderSection title="Nonprofit We'll Be Working With">
        <NonprofitInput onChange={this.onChangeNonprofit} selectedNonprofit={nonprofit} intl={this.hasIntl} allowClear />
      </BuilderSection>
    );
  }

  renderSectionCategory() {
    if (this.isEvent) return null;
    const { nteeCode, validations } = this.props;
    return (
      <BuilderSection title="Category" isRequired>
        <NteePicker nteeCode={nteeCode} onChange={this.onChangeNteeCode} allowMajor allowClear validations={validations} name="nteeCode" />
      </BuilderSection>
    );
  }

  renderSectionTags() {
    if (this.isEvent) return null;
    const {tags} = this.props;
    const ShowTags = Object.values(Tags).filter((tag) => {
      return ![Tags.REMOTE, Tags.IN_PERSON].includes(tag);
    });
    return (
      <BuilderSection title="Tags" className="cadmin-veb-tags">
        {ShowTags.map((showTag) => {
          const name = TagNames[showTag];
          const id = `cb-tag-${showTag}`;
          const checked = tags.includes(showTag);
          const IconComp = Icon[TagIcons[showTag]];
          return (
            <div key={id} className={`cadmin-veb-tags-tag ${checked ? 'on' : 'off'}`}>
              <Checkbox id={id} checked={checked} onChange={this.onChangeTag.bind(this, showTag)} isToggle offOk />
              <label htmlFor={id}><IconComp className="cadmin-veb-tags-tag-icon" /> {name}</label>
            </div>
          );
        })}
      </BuilderSection>
    );
  }

  renderSectionGroups() {
    const { groups, company, showGroupRequiredValidation, primaryGroupId } = this.props;
    if (!company.features.groups) return null;
    const isRequired = company.requireGroupOnEvents;
    const showPrimaryExp = groups.length > 1;
    return (
      <BuilderSection title="Group Support" isRequired={isRequired}>
        {showGroupRequiredValidation && (
          <p className="cadmin-builder-section-vmsg">At least one group is required.</p>
        )}
        {showPrimaryExp && (
          <p className="cadmin-builder-section-expmsg">One group must be the primary group - attendance and time entries will be associated with this group for analytics.</p>
        )}
        {groups.map((group, index) => {
          const isPrimary = group?.id && group?.id === primaryGroupId;
          const showPrimary = !isPrimary && !!group?.id;
          return (
            <BuilderIterable index={index} key={index} onDelete={this.onRemoveGroup} isPrimary={isPrimary} onSetPrimary={showPrimary ? this.onSetPrimaryGroup : null}>
              <EntityInput.Group onChange={this.onChangeGroup.bind(this, index)} groupId={group?.id} publishStatuses={Ps.nonDeleted} />
            </BuilderIterable>
          );
        })}
        <button className="btn small blue cadmin-builder-iterable-add" onClick={this.onClickAddGroup}>+ Add Group</button>
      </BuilderSection>
    );
  }

  renderSectionDetails() {
    const { details, contact, company, leadEmployee } = this.props;
    const detailsPlaceholder = 'We’re going to meet at the location at 8:45. Come wearing your company t-shirts and get ready for a fun, impactful 4 hours! We’ll try to grab lunch together afterwards.';
    const contactPlaceholder = 'If you have any questions feel free to reach out to Charlie — 123-123-1234 or…';

    return (
      <BuilderSection title="Details">
        <label>Event Details</label>
        <StandardInput type="textarea" label={detailsPlaceholder} name="details" value={details || ''} onChange={this.onChangeDetails} />
        <label>Event Lead</label>
        <EntityInput.Employee onChange={this.onChangeLeadEmployee} employeeId={leadEmployee?.id} label="Employee" />
        <label>Contact</label>
        <StandardInput type="textarea" label={contactPlaceholder} name="contact" value={contact || ''} onChange={this.onChangeContact} />
      </BuilderSection>
    );
  }

  renderSectionCalendar() {
    const {ffNylas, nylasCalendarId, isOngoing, volEventId, isSystemEvent} = this.props;
    if (!ffNylas) return null;
    if (volEventId) return null; // only set upon creation for now
    if (isOngoing) return null;
    if (isSystemEvent) return null;

    return (
      <BuilderSection title="Calendar Integration">
        <label>Sync to connected calendar</label>
        <CalendarPicker value={nylasCalendarId} onChange={this.onChangeNylasCalendarId} defaultWhenNull={!volEventId} />
      </BuilderSection>
    );
  }

  renderSectionSocial() {
    const {hasSocialFeed} = this.props;
    return (
      <BuilderSection title="Activity Feed">
        <div className="cadmin-builder-checkbox">
          <Checkbox id="cb-camp-has-social" onChange={this.onChangeHasSocialFeed} checked={hasSocialFeed} isToggle offOk />
          <label htmlFor="cb-camp-has-social">Include Activity Feed</label>
        </div>
      </BuilderSection>
    );
  }

  renderFooter() {
    const {hasTouched, savePending, isValid, volEventId, hasSubmitted, storedEvent} = this.props;
    const showValidation = hasSubmitted && !isValid;
    const disabled = !hasTouched || savePending || showValidation;
    const isActiveish = Ps.isActiveish(storedEvent?.publishStatus);
    const btnText = volEventId
      ? isActiveish
        ? (savePending ? 'Publishing...' : 'Save & Publish')
        : (savePending ? 'Saving...' : 'Save')
      : (savePending ? 'Creating...' : 'Create Draft');

    return (
      <BuilderFooter className="cadmin-veb-bottom">
        {showValidation && (
          <div className="cadmin-builder-bottom-validations">
            <p>Oops! There are some required fields above that need your attention.</p>
          </div>
        )}
        <div className="cadmin-builder-bottom-actions">
          <button className="btn green" disabled={disabled} onClick={this.onClickSave}>{btnText}</button>
        </div>
      </BuilderFooter>
    );
  }

  render() {
    const {shiftDeleteIndex} = this.state;

    return (
      <Builder footer={this.renderFooter()} className="cadmin-veb">
        {this.renderSectionTitle()}
        {this.renderSectionImg()}
        {this.renderSectionDescription()}
        {this.renderSectionLocation()}
        {this.renderSectionTime()}
        {this.renderSectionCalendar()}
        {this.renderSectionNonprofit()}
        {this.renderSectionCategory()}
        {this.renderSectionTags()}
        {this.renderSectionGroups()}
        {this.renderSectionDetails()}
        {this.renderSectionSocial()}

        {(shiftDeleteIndex != null) && (
          <Confirm onResponse={this.onResponseDeleteShift} confirmBtnLabel="Delete Shift" confirmBtnColor="danger">
            <p>Deleting this shift <strong>will also delete all volunteer registrations and logged hours</strong> associated with this shift.</p>
            <p><strong>This change can not be undone.</strong> It will take effect when you save the event you are editing.</p>
          </Confirm>
        )}
      </Builder>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  isSystemEvent: CadminSlx.company(state).id === config.systemEventsCompanyId,

  ffNylas: FfSlx.nylas(state),
  calendars: IntsDuck.Slx.validCalendars(state),

  volEventId: BuilderSlx.volEventId(state),
  hasTouched: BuilderSlx.hasTouched(state),
  hasLoaded: BuilderSlx.hasLoaded(state),
  hasSubmitted: BuilderSlx.hasSubmitted(state),
  isValid: BuilderSlx.isValid(state),
  validations: BuilderSlx.visibleValidations(state),
  showShiftRequiredValidation: BuilderSlx.showShiftRequiredValidation(state),
  showGroupRequiredValidation: BuilderSlx.showGroupRequiredValidation(state),
  savePending: BuilderSlx.savePending(state),
  // attrs
  type: BuilderSlx.type(state),
  imgPath: BuilderSlx.imgPath(state),
  title: BuilderSlx.title(state),
  descriptionMd: BuilderSlx.descriptionMd(state),
  nteeCode: BuilderSlx.nteeCode(state),
  links: BuilderSlx.links(state),
  externalUrl: BuilderSlx.externalUrl(state),
  contact: BuilderSlx.contact(state),
  details: BuilderSlx.details(state),
  addressLine1: BuilderSlx.addressLine1(state),
  city: BuilderSlx.city(state),
  state: BuilderSlx.state(state),
  postalCode: BuilderSlx.postalCode(state),
  isRemote: BuilderSlx.isRemote(state),
  isHybrid: BuilderSlx.isHybrid(state),
  isOngoing: BuilderSlx.isOngoing(state),
  timezone: BuilderSlx.timezone(state),
  leadEmployee: BuilderSlx.leadEmployee(state),
  nonprofit: BuilderSlx.nonprofit(state),
  storedEvent: BuilderSlx.storedEvent(state),
  shifts: BuilderSlx.shifts(state),
  groups: BuilderSlx.groups(state),
  tags: BuilderSlx.tags(state),
  primaryGroupId: BuilderSlx.primaryGroupId(state),
  hasSocialFeed: BuilderSlx.hasSocialFeed(state),
  nylasCalendarId: BuilderSlx.nylasCalendarId(state),
});

const dispatchToProps = (dispatch) => ({
  setKeyVal: (key, val) => dispatch(BuilderAx.setKeyVal(key, val)),
  setKeyVals: (keyVals) => dispatch(BuilderAx.setKeyVals(keyVals)),
  setTag: (tag, checked) => dispatch(BuilderAx.setTag(tag, checked)),
  setNonprofit: (nonprofit) => dispatch(BuilderAx.setNonprofit(nonprofit)),
  addShift: () => dispatch(BuilderAx.addShift()),
  removeShift: (index) => dispatch(BuilderAx.removeShift(index)),
  setGroup: (group, index) => dispatch(BuilderAx.setGroup(group, index)),
  removeGroup: (index) => dispatch(BuilderAx.removeGroup(index)),
  setPrimaryGroup: (index) => dispatch(BuilderAx.setPrimaryGroup(index)),
  addLink: () => dispatch(BuilderAx.addLink()),
  updateLink: (index, link) => dispatch(BuilderAx.updateLink(index, link)),
  removeLink: (index) => dispatch(BuilderAx.removeLink(index)),
  save: () => dispatch(BuilderAx.save()),
  setHasChanges: (cb) => dispatch(RoutingAx.hasChanges(cb)),
  loadCals: () => dispatch(IntsDuck.Ax.loadCalendars()),
});

export default connect(stateToProps, dispatchToProps)(VolEventBuilder);
